module.exports = __webpack_public_path__ + "media/images/help/faq-fav-sp-d948e446d1c4dd4262293892035b5959.jpg";